package gr.tech.GRAttestation.sections.tables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.navigation.AdminSitePage
import gr.tech.GRAttestation.styles.grstyles.BPlaceholder
import gr.tech.GRAttestation.styles.grstyles.DefaultTableHeaderStyle
import gr.tech.GRAttestation.styles.grstyles.DefaultTableStyle
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.styles.noBorder
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun <T> ListTable(
    boxModifier: Modifier = Modifier,
    tableModifier: Modifier = Modifier,
    tableHeaders: List<String>,
    items: List<T>,
    rowContent: @Composable (item: T?) -> Unit
) {
    TableContainer(modifier = boxModifier) {
        Table(
            attrs = DefaultTableStyle.toModifier()
                .classNames("table")
                .then(tableModifier)
                .toAttrs()
        ) {
            Thead {
                Tr {
                    tableHeaders.forEach { header ->
                        Th(
                            attrs = DefaultTableHeaderStyle.toModifier()
                                .classNames("col")
                                .toAttrs()
                        ) {
                            Text(header)
                        }
                    }
                }
            }
            Tbody {
                if (items.isNotEmpty()) {
                    items.forEach { rowContent(it) }
                } else {
                    repeat(2) { rowContent(null) }
                }
            }
        }
    }
}

@Composable
fun TableContainer(
    modifier: Modifier = Modifier,
    tableElement: @Composable () -> Unit,
) {
    Box(
        modifier = Modifier
            .minWidth(100.percent)
            .height(100.percent)
            .backgroundColor(Colors.WhiteSmoke)
            .noBorder()
            .border(1.px, LineStyle.Solid, Colors.LightGray)
            .borderRadius(8.px)
            .overflow(
                overflowX = Overflow.Auto,
                overflowY = Overflow.Auto
            )
            .boxShadow(BoxShadow.of(
                offsetX = 0.px,
                offsetY = 10.px,
                blurRadius = 10.px,
                spreadRadius = 1.px,
                color = Color.rgba(0,0,0,0.1.toFloat())
            ))
            .then(modifier)
    ) {
        tableElement()
    }
}

/*
    Example use of the Table Container and the List Table. Provide the table headers,
    then start writing out what each Row should look like.
 */
@Deprecated("This is an example Table, do not use.")
@Composable
fun ExampleTable(
    items: List<Pair<Int, String>>
) {
    ListTable(
        tableHeaders = listOf("Store", "Representative", "Signed", "Created"),
        items = items,
        rowContent = { attestation ->
            Tr(Modifier.height(57.px).toAttrs()) {
                attestation?.let {
                    Td(
                        attrs = Modifier.maxWidth(250.px).whiteSpace(WhiteSpace.NoWrap)
                            .textOverflow(TextOverflow.Ellipsis).overflow(Overflow.Hidden).toAttrs()
                    ) {
                        Link(
                            path = AdminSitePage.Stores.passStoreId(it.first.toString()),
                            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
                            modifier = Modifier.textDecorationLine(TextDecorationLine.Underline)
                                .color(Theme.DarkGreen.rgb).cursor(Cursor.Pointer)
                        ) {
                            Text(it.first.toString())
                        }
                    }
                    Td { Text(it.second) }
                } ?: run {
                    repeat(4) {
                        Td { BPlaceholder() }
                    }
                }
            }
        }
    )
}
